/* eslint-disable linebreak-style */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';

import { Transition } from '@headlessui/react';
import { useLocation } from 'react-router-dom';

import Button from '../elements/Button';
import BrandIcon from './BrandIcon';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Programs', href: '/programs' },
  { label: 'Team', href: '/team' },
  { label: 'Get Involved', href: '/get-involved' },
];

export default function Header() {
  const [isCollapse, setIsCollapse] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const path = location.pathname;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (href) => (href === '/' ? path === '/' : path.startsWith(href));

  return (
    <header className={`header sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="flex justify-between px-4 lg:px-0 items-center">
        <BrandIcon />

        <button
          className="block text-theme-blue lg:hidden focus:outline-none cursor-pointer"
          onClick={() => setIsCollapse(!isCollapse)}
          aria-label="Toggle menu"
        >
          <svg className="w-8 h-8" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path className={`${isCollapse ? 'hidden' : 'block'}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            <path className={`${!isCollapse ? 'hidden' : 'block'}`} strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <ul className="hidden text-theme-blue tracking-wide items-center lg:flex flex-row mt-0">
        {navLinks.map((link) => (
          <li key={link.href}>
            <Button
              className={`${isActive(link.href) ? 'text-theme-purple font-semibold' : ''} font-medium text-base px-5 hover:text-theme-purple transition-colors duration-200 cursor-pointer`}
              type="link"
              href={link.href}
            >
              {link.label}
            </Button>
          </li>
        ))}
        <li>
          <Button
            className="font-medium text-base mx-auto ml-4 px-6 py-2.5 bg-theme-gold text-theme-blue rounded-xl hover:bg-theme-gold-dark hover:shadow-lg transition-all duration-200 cursor-pointer"
            type="link"
            href="/donate"
          >
            Donate
          </Button>
        </li>
      </ul>

      <Transition
        show={isCollapse}
        enter="transition-all duration-300"
        enterFrom="opacity-0 -translate-y-2"
        enterTo="opacity-100 translate-y-0"
        leave="transition-all duration-300"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 -translate-y-2"
      >
        <div className="transition duration-300 ease-in">
          <ul className="z-50 flex flex-col text-theme-blue tracking-wide my-4 absolute bg-white/95 backdrop-blur-md w-full shadow-lg rounded-b-2xl lg:hidden">
            {navLinks.map((link) => (
              <li key={link.href} className="py-3">
                <Button
                  className={`${isActive(link.href) ? 'text-theme-purple font-semibold' : ''} font-medium px-8 cursor-pointer`}
                  type="link"
                  href={link.href}
                >
                  {link.label}
                </Button>
              </li>
            ))}
            <li className="px-8 py-6">
              <Button
                className="block w-full text-center font-medium px-6 py-3 bg-theme-gold text-theme-blue rounded-xl hover:bg-theme-gold-dark transition duration-200 cursor-pointer"
                type="link"
                href="/donate"
              >
                Donate
              </Button>
            </li>
          </ul>
        </div>
      </Transition>
    </header>
  );
}
